var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"homeAddress"}},[_c('plugin'),_c('myAddress',{on:{"changeFN":_vm.changeAddressFN}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }